import React, { FC } from 'react';

type Props = {
  className?: string;
};

export const MinusIcon: FC<Props> = ({ className }) => (
  <svg
    width="7"
    height="3"
    viewBox="0 0 7 3"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.01732 1.78497L0.937559 2.40862L0.789062 1.19922L5.86883 0.575563L6.01732 1.78497Z"
      fill="white"
    />
  </svg>
);
